import { XMarkIcon } from "@heroicons/react/24/solid";
import { integerName } from "../../../app/utils";
import { AlertLevel } from "../../../components/AlertMessage";
import ButtonWithConfirm from "../../../components/ButtonWithConfirm";
import { useRemoveUserFromDistrictMutation } from "../../districts/districtsApiSlice";
import { UserDistrictViewModel } from "../usersApiSlice";

interface RemoveFromDistrictProps {
	selectedDistricts: UserDistrictViewModel[];
	isLoading: boolean;
	name: string;
	userId: number;
	resetTable: () => void;
	setIsLoading: (loading: boolean) => void;
}

export default function RemoveUserFromDistrict(props: RemoveFromDistrictProps) {
	const length = props.selectedDistricts.length;

	const [removeFromDistrict] = useRemoveUserFromDistrictMutation();

	async function handleRemove() {
		props.setIsLoading(true);

		const promises = props.selectedDistricts.map(async (district) => {
			await removeFromDistrict({
				districtId: district.districtID,
				userId: props.userId,
			})
				.unwrap()
				.catch((error) => {
					console.error(`Error removing user from district ${district.name}:`, error);
				});
		});

		await Promise.all(promises);
		props.resetTable();
	}

	return (
		<ButtonWithConfirm
			id="remove-from-districts-button"
			className="btn btn-neutral"
			disabled={length == 0 || props.isLoading}
			message={`Are you sure you want to remove ${props.name} from the ${length == 1 ? "selected district" : `${integerName(length)} selected districts`}?`}
			type={AlertLevel.Warning}
			confirmLabel="Yes"
			cancelLabel="No"
			onConfirm={handleRemove}>
			<XMarkIcon className="h-4 inline mr-2" />
			Remove
		</ButtonWithConfirm>
	);
}
